import i18n from "../../resources/I18n";
import { DsdModale } from "../DSD/DsdModale";
import { INavigationParcours, obtenirNavigationUrl } from "../../util/Navigation";
import FonctionUtilitaire from "../utils/FonctionUtilitaire";
import { useCybermetrieJAMPPContext } from "../utils/CybermetrieJAMPPContext";
import { CybermetriesJAMPP } from "../../util/CybermetrieJAMPP";
import { useEffect, useRef } from "react";
import { CybermetrieParamsJAMPP } from "../../models/CybermetrieParamsJAMPP";

interface IModaleEnregistrerProps {
  modaleOuvert: boolean;
  onClickModaleEnregistrerFermer: Function;
  dateExpirationOffre?: Date;
  cookieParcoursAssurance: INavigationParcours;
  parcours: string;
}

function retournerDateEcheance(date?: Date) {
  let dateEcheance = new Date(date);
  let dateFormater;

  if (i18n.language === "en") {
    dateFormater = FonctionUtilitaire.dateToJJMoisAAAA(dateEcheance, "en");
  } else {
    dateFormater = FonctionUtilitaire.dateToJJMoisAAAA(dateEcheance, "fr");
  }

  return dateFormater;
}

function ModaleEnregistrer(props: Readonly<IModaleEnregistrerProps>) {
  let cybermetriesParams = useCybermetrieJAMPPContext();
  const ancienneValeurCybermetrieParams = useRef(new CybermetrieParamsJAMPP());

  useEffect(() => {
    ancienneValeurCybermetrieParams.current = cybermetriesParams;
  }, [cybermetriesParams]);

  const onClickBoutonEnregistrer = () => {
    CybermetriesJAMPP.EnvoieClicBoutonEnregistrerQuitter(ancienneValeurCybermetrieParams.current);

    window.location.href = `${obtenirNavigationUrl(props.cookieParcoursAssurance.idCallback)}redirection/${
      props.parcours
    }/${props.cookieParcoursAssurance.langue}/saveandquit?idSouscription=${
      props.cookieParcoursAssurance.idSouscription
    }&idAssure=${props.cookieParcoursAssurance.idAssure}`;
  };

  return (
    <DsdModale
      id="dsd-modal-enregistrer"
      dataTestId="dsd-modal-enregistrer"
      show={props.modaleOuvert}
      buttonPrimaryLabel={i18n.t("jampp:bouton-principal-modale-enregistrer-et-quitter")}
      buttonSecondaryLabel={i18n.t("jampp:bouton-secondaire-modale-enregistrer-et-quitter")}
      dsdModalSecondaryClick={props.onClickModaleEnregistrerFermer}
      dsdModalPrimaryClick={onClickBoutonEnregistrer}
      spanSlotTitle={i18n.t("jampp:titre-modale-enregistrer-et-quitter")}
    >
      <p>
        <span dangerouslySetInnerHTML={{ __html: i18n.t("jampp:prefix-texte-modale-enregistrer-et-quitter") }}></span>
        <b>{retournerDateEcheance(props.dateExpirationOffre)}</b>
        <span dangerouslySetInnerHTML={{ __html: i18n.t("jampp:sufix-texte-modale-enregistrer-et-quitter") }}></span>
      </p>
    </DsdModale>
  );
}

export default ModaleEnregistrer;
